import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { getFestivalTheme } from './utils/festivalTheme';
import { initScrollReveal } from './utils/scrollReveal';
import FestivalBanner from './components/FestivalBanner';
import Navbar         from './components/Navbar';
import Footer         from './components/Footer';
import Chatbot        from './components/chatbot';
import NotFound       from './components/NotFound';        /* ← ADD */
import Hero           from './components/Hero';
import Stats          from './components/Stats';
import WhyChooseUs    from './components/WhyChooseUs';
import About          from './components/About';
import Services       from './components/Services';
import ServiceDetail  from './components/ServiceDetail';
import Industries, { IndustryDetailPage } from './components/Industries';
import Contact        from './components/Contact';
import Career         from './components/Career';
import Teammember     from './components/Teammember';

function ScrollRevealInit() {
  const location = useLocation();
  useEffect(() => {
    const timer = setTimeout(() => initScrollReveal(), 300); /* ← 100 to 300 */
    return () => clearTimeout(timer);
  }, [location.pathname]);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function HomePage() {
  return (
    <main>
      <Hero />
      <Stats />
      <WhyChooseUs />
    </main>
  );
}

export default function App() {
  const festival = getFestivalTheme();
  const bannerHeight = festival.active ? 38 : 0;

  return (
    <BrowserRouter>
      <div style={{           /* ← updated */
        paddingTop: bannerHeight,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <FestivalBanner />
        <Navbar />
        <ScrollRevealInit />
        <ScrollToTop />

        <div style={{ flex: 1 }}>   {/* ← ADD wrapper */}
          <Routes>
            <Route path="/"                   element={<HomePage />} />
            <Route path="/about"              element={<main><About /></main>} />
            <Route path="/services"           element={<main><Services /></main>} />
            <Route path="/services/detail"    element={<main><ServiceDetail /></main>} />
            <Route path="/industries"         element={<main><Industries /></main>} />
            <Route path="/contact"            element={<main><Contact /></main>} />
            <Route path="/career"             element={<main><Career /></main>} />
            <Route path="/teammember"         element={<main><Teammember /></main>} />
            <Route path="*"                   element={<NotFound />} />  {/* ← updated */}
          </Routes>
        </div>                      {/* ← close wrapper */}

       {/* * <Chatbot /> */}
        <Footer />
      </div>
    </BrowserRouter>
  );
}